import { SalesActionsType } from 'api-hooks/general/model';
import { SaleModel } from 'api-hooks/sale/common';
import { AuthorizationRules } from 'common/constants';
import { SaleStatusEnum } from 'common/constants/enum';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import OpenTicketPanel from '../ticket-sale/components/open-ticket/panel';

export default function useFlightOpenTicket(
  data: SaleModel,
  type: SalesActionsType,
) {
  const { can } = useAuthorization();
  const { t } = useTranslation();
  const status = data.status;
  const isAllowed = React.useMemo(() => {
    switch (status) {
      case SaleStatusEnum.Active:
      case SaleStatusEnum.OpenTicket:
        return true;
      default:
        return false;
    }
  }, [status]);

  const openTicketPermission =
    isAllowed &&
    can(AuthorizationRules.FlightSalesOpenTicket) &&
    type === 'flight-sales';

  const drawer = useDrawer();

  const onOpenTicket = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (onClose) => (
        <OpenTicketPanel onClose={onClose} refId={data.refId} />
      ),
    });
  }, [data.refId, drawer]);

  const openTicketAction: PopoverMenuType = {
    label: t('common:open_ticket'),
    isAllowed: openTicketPermission,
    onClick: onOpenTicket,
    key: `open-ticket-${data.id}`,
  };

  return {
    openTicketPermission,
    onOpenTicket,
    openTicketAction,
  };
}
